import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { useFeedbackMessages, useHandleFeedbackMessage, FeedbackMessageModel } from '../../hooks/useFeedbackMessages';
import FeedbackMessageList from '../feedbackmessage/FeedbackMessageList';
import AdminFeedbackMessageModal from './AdminFeedbackMessageModal';

function AdminFeedbackMessagesPage() {
    const [selectedMessage, setSelectedMessage] = React.useState<FeedbackMessageModel>({} as FeedbackMessageModel);
    const [showModal, setShowModal] = React.useState(false);
    const [messageSent, setMessageSent] = React.useState(false);

    const { data: messages = [] } = useFeedbackMessages();
    const handleFeedbackMutation = useHandleFeedbackMessage();

    function openAdminModal(message: FeedbackMessageModel) {
        setSelectedMessage(message);
        setShowModal(true);
        setMessageSent(false);
    }

    function openSite(siteId: number) {
        window.open(window.location.origin + '/administrationsiteinfo/' + siteId, '_blank');
    }

    function handleModalClose() {
        setShowModal(false);
    }

    function markFeedbackAsDone(message: FeedbackMessageModel) {
        handleFeedbackMutation.mutate(message.feedbackMessageId, {
            onSuccess: () => setMessageSent(true)
        });
    }

    return (
        <div>
            <FeedbackMessageList messages={messages} openAdminModal={openAdminModal} openSite={openSite} />
            <AdminFeedbackMessageModal
                message={selectedMessage}
                openSite={openSite}
                close={handleModalClose}
                show={showModal}
                markAsDone={markFeedbackAsDone}
                messageSent={messageSent} />
        </div>
    );
}

export default withTranslation('translations')(AdminFeedbackMessagesPage);
